<template>
	<div class="accountDetection">
		<!-- tab切换 -->
		<div class="tab_list">
			<sky-tabs v-model="tabValue" :tabList="tabList"></sky-tabs>
		</div>

		<!-- tab显示主体 -->
		<div class="tab_body">
			<component :is="tabValue"></component>
		</div>
	</div>
</template>

<script>
import skyTabs from '@/components/iglobalwin/formComponents/tabs/sky-tabs-custom.vue';
import adDetection from './adDetection';
import sKeywordDet from './sKeywordDet.vue';

export default {
	name: 'accountDetection',
	props: [],
	components: {
		skyTabs,
		adDetection,
		sKeywordDet,
	},
	data() {
		return {
			tabValue: 'adDetection',
			tabList: [
				{
					label: '广告语检测',
					name: 'adDetection',
				},
				{
					label: '自动出价检测（敬请期待）',
					name: 'adDetection1',
					disabled: true,
				},
				{
					label: '搜索关键词判定',
					name: 'sKeywordDet',
				},
			],
		};
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>

<style lang="scss" scoped>
.accountDetection {
	.tab_list {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		padding: 10px 30px;
		border-bottom: 1px solid #e8e8e8;
	}

	.tab_body {
		margin-top: 20px;
	}
}
</style>
